import { render, staticRenderFns } from "./test.vue?vue&type=template&id=5fead14a&scoped=true&"
import script from "./test.vue?vue&type=script&lang=ts&"
export * from "./test.vue?vue&type=script&lang=ts&"
import style0 from "./test.vue?vue&type=style&index=0&id=5fead14a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fead14a",
  null
  
)

export default component.exports